import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const ForwardedOverlayTrigger = React.forwardRef((props, ref) => (
  <OverlayTrigger {...props} ref={ref} />
));

const CaseListToolTip = props => {
    return (
        <ForwardedOverlayTrigger
            animation={false}
            id={'ot' + props.id}
            key={'kt' + props.id}
            placement="top"
            overlay={<Tooltip key={'tkt' + props.id} id={props.id}>{props.caption}</Tooltip>}
        >
            {props.children}
        </ForwardedOverlayTrigger>
    );
};

export default CaseListToolTip;
